export var DownloadResultCode;
(function (DownloadResultCode) {
    DownloadResultCode["SUCCESS"] = "SUCCESS";
    DownloadResultCode["ALREADY_DOWNLOADED"] = "ALREADY_DOWNLOADED";
    DownloadResultCode["DOWNLOADING"] = "DOWNLOADING";
    DownloadResultCode["NOT_SUPPORTED"] = "NOT_SUPPORTED";
    DownloadResultCode["ERROR"] = "ERROR";
})(DownloadResultCode || (DownloadResultCode = {}));
//# sourceMappingURL=MediaControlInterface.js.map